import { roleLabel } from "@/components/UserMenu";
import { TaskCard } from "@/components/tasks/TaskCard";

const COLUMNS = ["Open", "In Progress", "Blocked", "Done – Pending Verification", "Verified", "Auto-closed"];
const slug = (value) => value.toLowerCase().replace(" – ", "-").replaceAll(" ", "-");

export const TeamBoard = ({ tasks, onOpen }) => (
  <section className="task-board" data-testid="task-team-board">
    {COLUMNS.map((column) => {
      const items = tasks.filter((t) => t.status === column);
      return (
        <div className="task-board-column" key={column} data-testid={`task-board-column-${slug(column)}`}>
          <header><h3>{column}</h3><span>{items.length}</span></header>
          <div className="task-board-items">
            {items.map((task) => <TaskCard key={task.id} task={task} onOpen={onOpen} compact />)}
            {!items.length && <p className="pairing-meta">Nothing here.</p>}
          </div>
        </div>
      );
    })}
  </section>
);

export const MeetingView = ({ groups, onOpen }) => (
  <section className="task-meeting" data-testid="task-meeting-view">
    {groups.map((group) => (
      <article className="task-meeting-group" key={group.owner_id} data-testid={`meeting-owner-${group.owner_id}`}>
        <header>
          <div><h3>{group.owner_name}</h3><p>{roleLabel(group.owner_role)}</p></div>
          <div className="task-meeting-counts">
            <span className={group.overdue ? "status-chip status-inactive" : "status-chip status-neutral"} data-testid={`meeting-overdue-${group.owner_id}`}>{group.overdue} overdue</span>
            <span className="status-chip status-neutral">{group.open} open</span>
            {group.awaiting_verification > 0 && <span className="status-chip status-review">{group.awaiting_verification} awaiting verification</span>}
          </div>
        </header>
        <div className="task-meeting-items">
          {group.tasks.map((task) => <TaskCard key={task.id} task={task} onOpen={onOpen} compact />)}
        </div>
      </article>
    ))}
    {!groups.length && <p className="operations-empty-state" data-testid="task-meeting-empty">No open tasks for the Tuesday meeting.</p>}
  </section>
);
